module.exports = __webpack_public_path__ + "media/icons/bed-36568386.svg";